<template>
  <div>
    <el-button type="primary" @click="showModal">
      表头设置
    </el-button>
    <a-modal
      title="表头设置"
      :visible="visible"
      ok-text="保存"
      cancel-text="关闭"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <el-table :data="headerConfig" border size="medium">
        <el-table-column prop="label" label="字段" align="center" />
        <el-table-column prop="name" label="是否展示" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-if="
                row.prop !== 'orderName' &&
                  row.prop !== 'competitionName' &&
                  row.label !== '序号' &&
                  !row.fixed
              "
              v-model="row.isShow"
              active-color="#13ce66"
              inactive-color="#ff4949"
            />
          </template>
        </el-table-column>
      </el-table>
    </a-modal>
  </div>
</template>
<script>
import { saveHeaderSettingApi } from '@/api/project-view/index'

import { cloneDeep } from 'lodash'
export default {
  props: {
    tableConfig: {
      type: Array,
      default: () => []
    },
    purchaseType: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      visible: false,
      headerConfig: []
    }
  },

  methods: {
    /**
     * 显示弹窗
     */
    showModal() {
      this.visible = true
      this.headerConfig = cloneDeep(this.tableConfig) || []
      this.headerConfig.unshift({ label: '序号', isShow: true })
    },

    /**
     * 确认修改表头
     */
    async handleOk() {
      await this.$confirm('请确认是否修改表头', '系统提示', { type: 'warning' })
      try {
        const headerList = this.headerConfig
          .filter(el => el.isShow)
          .filter(el => el.label !== '序号')
        let header = ''
        if (headerList.length) {
          header = headerList.map(el => el.prop).join(',')
        }
        await saveHeaderSettingApi(this.purchaseType, {
          headerList: header
        })
        this.$message.success('修改成功')
        this.handleCancel()
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    /**
     * 取消修改表头
     */
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
